import { compareVersions } from 'compare-versions';
import { isArray } from 'lodash';
import { Button } from '@meitu/saas-ui';
import message from '@meitu/saas-ui/es/message';
import { Editor } from '@meitu/saas-editor-core';
import { traverseTrees } from '@meitu/saas-editor-core/es/utils/tree-kit';
import { ILayerProps, StageType } from '@meitu/saas-editor-core/es/version-types';
import { isEditAIPPTComponent, isUploadAIPPTComponent } from '@/hooks/fetch-template/editor-mode';
import { getBaseTemplate, parseClientToServerLayers } from '@/hooks/save-template/client-to-server';
import { getPPTMark } from '@/services/ai';
import { getTemplateDpi } from '@/services/template';
import { useStoreState } from '@/store';

const TemplateMarkBtn: React.FC<{
    editor: Editor;
}> = ({ editor }) => {
    const canvasType = useStoreState((state) => state.templateModel.canvasType);
    const resolution = useStoreState((state) => state.templateModel.resolution);

    const markClick = async (isCategory = false) => {
        try {
            const resultStages = await editor.download.getResult(false);
            const unit = editor.stage.getUnit();
            const allLayers: any[] = [];
            for (let i = 0; i < resultStages.length; i++) {
                const element = resultStages[i];
                allLayers.push(...element.layers);
            }

            const stageType = editor.stage.getType();

            traverseTrees(allLayers, (child: ILayerProps) => {
                if (!child.extraInfo) {
                    child.extraInfo = {};
                }
            });

            const { layers: serviceLayers, version: currentVersion } = parseClientToServerLayers(
                allLayers,
                stageType === StageType.VARIETY || (stageType === StageType.SINGLE && resultStages.length > 1),
                { unit, resolution: getTemplateDpi() },
            );

            let index = 0;
            for (let i = 0; i < resultStages.length; i++) {
                const element = resultStages[i];
                for (let j = 0; j < element.layers.length; j++) {
                    element.layers[j] = serviceLayers[index] as any;
                    index = index + 1;
                }
            }

            const max7Version = compareVersions(currentVersion, '7.0.0');

            const baseTemplate = getBaseTemplate({
                preview: '',
                name: '',
                version: currentVersion,
                templateConf: max7Version >= 0 ? resultStages : resultStages[0],
                editMode: canvasType,
                unit,
                resolution,
            });

            const formula = JSON.stringify(baseTemplate);
            const data = await getPPTMark({
                type:
                    isEditAIPPTComponent() || isUploadAIPPTComponent()
                        ? isCategory
                            ? 'table_content'
                            : 'content_component'
                        : 'ppt_template',
                formula,
            });

            if (!(data as any).data.response.labeled_formula) {
                message.error('打标失败');
                return;
            }
            const template = JSON.parse((data as any).data.response.labeled_formula);

            const templateConfigs = isArray(template.templateConf) ? template.templateConf : [template.templateConf];

            for (let i = 0; i < templateConfigs.length; i++) {
                const templateConfig = templateConfigs[i];
                const { extraInfo, layers } = templateConfig;

                const stageExtraInfo = editor.stage.getExtraInfo(i);
                editor.stage.setExtraInfo(i, {
                    ...stageExtraInfo,
                    extraInfo: {
                        ...(extraInfo || {}),
                    },
                });

                traverseTrees(layers, (child: ILayerProps) => {
                    const layer = editor.stage.getLayer(`${child.id}__${i}`);
                    if (layer) {
                        layer.extraInfo = {
                            ...(layer.extraInfo || {}),
                            ...(child.extraInfo || {}),
                        };
                        editor.stage.updateLayer({ ...layer });
                    }
                });
            }

            message.success('打标成功');
        } catch (error) {
            console.error(error);
            message.error('打标失败');
        }
    };

    return (
        <>
            <div style={{ marginRight: '10px' }}>
                <Button
                    type="primary"
                    data-blue
                    onClick={() => {
                        markClick(false);
                    }}
                >
                    智能打标
                </Button>
            </div>
            {/* <div style={{ marginRight: '10px' }}>
                <Button
                    type="primary"
                    data-blue
                    onClick={() => {
                        markClick(true);
                    }}
                >
                    目录打标
                </Button>
            </div> */}
        </>
    );
};

export default TemplateMarkBtn;
